import { PlusOutlined } from '@ant-design/icons'
import { Empty, FloatButton, Typography } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import car1 from "../../../assets/images/car1.jpg"
import car2 from "../../../assets/images/car2.jpg"
import car3 from "../../../assets/images/car3.jpg"
import defaultCar from "../../../assets/images/default-car.jpg"
import { BASE_URL } from '../../../constants/link'
import { thousandSeparator } from '../../../utils/numberManager'
import { useCars, useSoldCars } from '../../../zustand/store'
import Header from '../header'
import { CarImgWrapper, ItemWrapper, ListWrapper, Wrapper } from './styles'
import { Swiper, Tabs } from 'antd-mobile'


const list = [
    {
        id: 1,
        model: "Sanata",
        make: "Hyundai",
        year: 2020,
        expense: 1560,
        img: car1
    },
    {
        id: 2,
        model: "Spark",
        make: "Chevrolet",
        year: 2017,
        expense: 320,
        img: car2
    },
    {
        id: 3,
        model: "Sanata",
        make: "Hyundai",
        year: 2020,
        expense: 1560,
        img: car3
    },
    {
        id: 4,
        model: "Spark",
        make: "Chevrolet",
        year: 2017,
        expense: 320,
        // img: car4
    },
]

export const carList = list;

const CarImg = ({ src }) => {
    return (
        <CarImgWrapper>
            <img src={src || defaultCar} alt="image" />
        </CarImgWrapper>
    )
}

export const CarItem = ({ id, make, model, year, expense, image, price, addedAt }) => {
    const navigate = useNavigate();
    return <ItemWrapper onClick={() => {
        navigate(`/car/${id}`)
    }} >
        <CarImg
            src={
                image?.[0]?.file_id && `${BASE_URL}/file/${image?.[0]?.file_id}`
            }
        />
        <div className='data'>
            <div>
                <Typography.Text strong>
                    {make}/{model}
                </Typography.Text>
            </div>
            <div>
                <Typography.Text type="secondary">{year}</Typography.Text>
            </div>
        </div>
        <div className='rightside'>
            {/* <div className='expense'> */}
            <Typography.Text small style={{ textAlign: "right" }} strong align="right" >
                ${thousandSeparator(price)}
            </Typography.Text>

            <Typography.Text type="secondary">
                <small>
                    {dayjs(addedAt).format("DD/MMM/YY")}
                </small>
            </Typography.Text>
            {/* </div> */}
        </div>
    </ItemWrapper>
}


const Cars = ({ cars }) => {

    useEffect(() => {
        cars.execute();
    }, [])
    return <>
        {
            cars.success && !cars.data?.length ?
                <div style={{ height: "calc(100vh - 200px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Empty />
                </div> :
                <ListWrapper>
                    {cars.data?.map((data) => (
                        <>
                            <CarItem {...data} />
                        </>
                    ))}
                </ListWrapper>
        }
    </>
}



function CarsPage() {
    const navigate = useNavigate();
    const cars = useCars();
    const soldCars = useSoldCars();

    const swiperRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(0)

    const list = [
        {
            title: "Active",
            key: "active",
            children: <Cars cars={cars} />
        },
        {
            title: "Sold",
            key: "sold",
            children: <Cars cars={soldCars} />
        },
    ]

    return (
        <Wrapper>

            {/* <Header title="Cars" /> */}
            <>
                <Tabs
                    style={{ backgroundColor: "white" }}
                    activeKey={list[activeIndex].key}
                    onChange={key => {
                        const index = list.findIndex(item => item.key === key)
                        setActiveIndex(index)
                        swiperRef.current?.swipeTo(index)
                    }}
                >
                    {list.map(item => (
                        <Tabs.Tab title={item.title} key={item.key} />
                    ))}
                </Tabs>
                <Swiper
                    direction='horizontal'
                    loop
                    indicator={() => null}
                    ref={swiperRef}
                    defaultIndex={activeIndex}
                    onIndexChange={index => {
                        setActiveIndex(index)
                    }}
                >
                    {
                        list.map((item) => (
                            <Swiper.Item>
                                {item.children}
                            </Swiper.Item>
                        ))
                    }
                </Swiper>
                <Tabs
                // style={{ width: "100%" }}
                // items={}

                />

            </>
            <FloatButton onClick={() => {
                navigate("/car/new")
            }} type='primary' size={"large"} icon={<PlusOutlined />} />
        </Wrapper>
    )
}

export default CarsPage